// Escape = back, everywhere.
//
// Mounted once inside the router. Desktop has no hardware back button, so
// without this the only way out of a screen is finding its arrow — and a few
// screens (the kiosk Wall Mode, the message console) fill the window.
//
// THREE THINGS IT DELIBERATELY DOES NOT DO
//
// 1. It never fires while a dialog is open. MUI already closes dialogs on
//    Escape; navigating as well would close the dialog AND leave the page in one
//    keypress, which feels like the app lost your place.
//
// 2. From a text field, the first Escape just blurs. Pressing Escape while
//    typing in a search box means "get me out of this field", not "leave the
//    page". A second press then navigates.
//
// 3. It does nothing on a root screen. Escape on /home should not drop you onto
//    a blank history entry or the login page.

import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const ROOT_PATHS = ['/home', '/login', '/splash', '/blocked'];

const isTextEntry = (el) => {
  if (!el) return false;
  const tag = el.tagName;
  return tag === 'INPUT' || tag === 'TEXTAREA' || el.isContentEditable;
};

// A MUI Dialog/Menu/Popover renders into a .MuiModal-root portal.
const modalOpen = () => !!document.querySelector('.MuiModal-root');

export default function EscapeBack() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onKey = (e) => {
      if (e.key !== 'Escape' || e.defaultPrevented) return;
      if (modalOpen()) return;

      const active = document.activeElement;
      if (isTextEntry(active)) { active.blur(); return; }

      if (ROOT_PATHS.includes(location.pathname)) return;
      navigate(-1);
    };

    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [navigate, location.pathname]);

  return null;
}
